module.exports = __webpack_public_path__ + "img/Z3RO_2.df66c07a.png";